<template>
  <div v-loading.body="loading" class="work-list">
    <div class="c_page-title" style="position: relative">
      <div>售后工单商品列表</div>
      <div style="position: absolute; right: 0">
        <el-button size="mini" type="primary" @click="redireToWork">
          客服工单</el-button
        >
      </div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询条件</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px 0">
              <el-form
                ref="form"
                :model="form"
                label-width="100px"
                style="margin-bottom: 10px"
                @keyup.native.enter="search"
              >
                <el-row :gutter="10">
                  <el-col>
                    <el-form-item label="输入搜索：">
                      <el-col :span="2">
                        <el-select
                          v-if="address"
                          v-model="form.city"
                          placeholder="地区"
                        >
                          <el-option
                            v-for="item1 in address"
                            :key="item1.key"
                            :label="item1.label"
                            :value="item1.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="searchOptions"
                          v-model="key_word"
                          placeholder="搜索内容"
                          @change="getKeyWord"
                        >
                          <el-option
                            v-for="item in selectChooseList"
                            :key="item.key"
                            :label="item.text"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="2"
                        style="margin-left: -10px; width: 200px"
                      >
                        <el-input
                          v-model="key_content"
                          placeholder="输入搜索内容"
                        ></el-input>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="searchOptions"
                          v-model="form.handle_status"
                          placeholder="工单状态"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in searchOptions.handle_status"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="searchOptions"
                          v-model="form.policy"
                          placeholder="政策类型"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in searchOptions.policy"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-if="searchOptions"
                          v-model="form.handle_type"
                          placeholder="工单类型"
                        >
                          <el-option label="全部" value=""></el-option>
                          <el-option
                            v-for="item in searchOptions.handle_type"
                            :key="item.key"
                            :label="item.label"
                            :value="item.key"
                          ></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">
                        <el-select
                          v-model="form.is_son_order"
                          placeholder="是否子工单"
                        >
                          <el-option label="全部" value="0"></el-option>
                          <el-option label="是" value="1"></el-option>
                          <el-option label="否" value="2"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="7">
                        <el-form-item label="登记时间：">
                          <el-date-picker
                            v-model="form.create_time"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['06:00:00', '06:00:00']"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col :span="1">
                        <div class="_ctrl-item">
                          <el-button type="primary" @click="search">
                            查询</el-button
                          >
                          <el-button type="primary" @click="showSearch">
                            <i class="el-icon-arrow-down" />
                          </el-button>
                        </div>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div v-if="show_search">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <div>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-input
                      v-model="form.goods_name"
                      placeholder="商品名称"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-input v-model="form.sku" placeholder="sku"></el-input>
                  </el-form-item>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-input
                      v-model="form.goods_kh"
                      placeholder="商品款号 "
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-input
                      v-model="form.co_val"
                      placeholder="颜色 "
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-input
                      v-model="form.si_val"
                      placeholder="尺码"
                    ></el-input>
                  </el-form-item>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-select
                      v-model="form.unpack_status"
                      placeholder="拆包状态"
                    >
                      <el-option label="全部" value="0"></el-option>
                      <el-option
                        v-for="item in searchOptions &&
                        searchOptions.unpack_status"
                        :key="item.key"
                        :label="item.label"
                        :value="item.key"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item style="margin: 0 0 10px 25px">
                    <el-select
                      v-model="form.is_artificial_damage"
                      placeholder="是否人为次品"
                    >
                      <!-- <el-option label="全部" value="0"></el-option> -->
                      <el-option
                        v-for="item in artificialDamageSearchList"
                        :key="item.key"
                        :label="item.text"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-form-item label="拆包时间：">
                  <el-date-picker
                    v-model="form.chaibao_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="寄出时间：">
                  <el-date-picker
                    v-model="form.send_time"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :default-time="['06:00:00', '06:00:00']"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
            position: relative;
          "
        >
          <div>数据列表：</div>
          <div style="position: absolute; right: 0">
            <el-upload
              style="display: inline-block; margin-left: 20px"
              :action="action"
              name="file"
              :on-success="importSuccess"
              :on-error="importError"
              :show-file-list="false"
              with-credentials
            >
              <el-button size="small" type="primary">
                导入用户寄回物流信息</el-button
              >
            </el-upload>
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              prop="id"
              label="工单ID"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="imgs" label="商品图片" align="center">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.imgs.length > 0"
                  style="width: 70px; height: 70px"
                >
                  <img
                    :src="scope.row.goods_img"
                    style="width: 100%; height: 100%"
                    @click="showImages(scope.row.imgs)"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="order_id"
              label="颜色/尺码/件数"
              align="center"
              width="130"
            >
              <template slot-scope="scope">
                {{ scope.row.co_val }}/ {{ scope.row.si_val }}/
                {{ scope.row.num }}
              </template>
            </el-table-column>
            <el-table-column prop="sku" label="sku" align="center" width="100">
            </el-table-column>
            <el-table-column
              label="发货地"
              prop="goods_lib_origin"
            ></el-table-column>
            <el-table-column
              prop="add_time"
              label="生成时间"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="user_id"
              label="用户id"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="service_order_policy"
              label="政策类型"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="service_order_handle_type"
              label="工单类型"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="is_son_order"
              label="是否子工单"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="order_sn" label="订单号" align="center">
              <template slot-scope="scope">
                <span
                  class="order_sn_style"
                  @click="redireToOrder(scope.row.order_id)"
                  >{{ scope.row.order_sn }}</span
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="first_problem"
              label="一级问题"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="second_problem"
              label="二级问题"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refund_reason"
              label="寄回原因"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="problem_desc"
              label="问题描述"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="kf_remark" label="客服备注" align="center">
            </el-table-column>
            <el-table-column
              prop="service_order_handle_status"
              label="工单状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              label="是否人为"
              show-overflow-tooltip
              align="center"
              prop="so_is_artificial_damage_text"
            >
            </el-table-column>
            <el-table-column prop="back_time" label="拆包时间" align="center">
            </el-table-column>
            <el-table-column
              prop="c_num"
              label="已拆数量"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="c_status"
              label="拆包状态"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.abnormal_status != 2" style="color: red">
                  {{ scope.row.c_status }}
                </div>
                <div v-if="scope.row.abnormal_status == 2">
                  {{ scope.row.c_status }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="service_order_ext_cb_has_shipping_num"
              label="拆包时是否已绑定运单"
              show-overflow-tooltip
              align="center"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop="back_shipping_num"
              label="用户寄回运单号"
              show-overflow-tooltip
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="shipping_nums"
              label="仓库拆包寄回运单号"
              show-overflow-tooltip
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="拆包人"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column prop="dbids" label="打标id" align="center">
            </el-table-column>
            <el-table-column prop="dbid_note" label="拆包备注" align="center">
            </el-table-column>
            <el-table-column
              prop="owe_num"
              label="不良品数量"
              show-overflow-tooltip
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column prop="allot_num" label="配货数量" align="center">
            </el-table-column>
            <el-table-column prop="shipped_num" label="发货数量" align="center">
            </el-table-column>
            <el-table-column
              prop="out_shipping_num"
              label="寄出运单号"
              show-overflow-tooltip
              align="center"
              width="120"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="show_ship(scope.row.out_shipping_num)"
                  >{{ scope.row.out_shipping_num }}</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="out_shipping_time"
              label="寄出时间"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="out_shipping_time"
              label="日志"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <el-button type="text" @click="showLogList(scope.row.id)">
                  查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              show-overflow-tooltip
              align="center"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.handle_type_index != 2">
                  <div
                    v-if="
                      scope.row.handle_status_index != 1 &&
                      scope.row.handle_status_index != 0 &&
                      scope.row.handle_status_index != 7 &&
                      scope.row.handle_status_index != 8
                    "
                  >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleEdit(scope.row.id)"
                    >
                      <span v-if="scope.row.handle_type_index == 1">编辑</span>
                      <span v-if="scope.row.handle_type_index == 5">查看</span>
                    </el-button>
                  </div>
                  <div
                    v-if="
                      scope.row.handle_status_index == 7 ||
                      scope.row.handle_status_index == 8
                    "
                  >
                    <el-button
                      type="primary"
                      size="mini"
                      @click="handleEdit(scope.row.id)"
                    >
                      查看
                    </el-button>
                  </div>
                </div>
                <div v-if="scope.row.handle_status_index == 3">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="doSendBf(scope.row.id)"
                  >
                    补发寄出
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper"
            :total="resData.count"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!--编辑查看地址-->
    <div v-if="showEdit">
      <cb-address-info :work_id="work_id" @onCloseDialog="onCloseDialog">
      </cb-address-info>
    </div>

    <!--查看日志-->
    <div v-if="showLog">
      <work-log :work_id="work_id" @onCloseDialog="onCloseDialog"></work-log>
    </div>

    <div v-if="sendBf">
      <send-bf :work_id="work_id" @onCloseDialog="onCloseDialog"></send-bf>
    </div>

    <preview-image
      :imgs="images"
      :show="showbox"
      @closeBox="closeBox()"
    ></preview-image>
  </div>
</template>

<script>
import CbAddressInfo from "./components/CbAddressInfo.vue";
import WorkLog from "./components/WorkLog.vue";
import SendBf from "./components/SendBf.vue";
import PreviewImage from "../../components/PreviewImage.vue";
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  components: {
    CbAddressInfo,
    WorkLog,
    PreviewImage,
    SendBf,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.form.create_time = vm.defaultDate();
      vm.fetchData();
    });
  },
  data() {
    return {
      images: [],
      showbox: false,
      key_word: "back_shipping_num",
      key_content: "",
      address: [
        {
          key: "0",
          label: "全部",
        },
        {
          key: "1",
          label: "广州",
        },
        {
          key: "2",
          label: "杭州",
        },
      ],
      selectChooseList: [
        {
          key: "back_shipping_num",
          text: "寄回运单号",
        },
        {
          key: "mobile",
          text: "订单手机号",
        },
        {
          key: "work_id",
          text: "工单id",
        },
        {
          key: "user_id",
          text: "用户id",
        },
        {
          key: "order_sn",
          text: "订单号",
        },
        {
          key: "out_shipping_num",
          text: "寄出运单号",
        },
        {
          key: "admin_name",
          text: "拆包登记人",
        },
        // {
        //     key : 'goods_no',
        //     text: '商品货号'
        // },
        // {
        //     key : 'sku',
        //     text: 'sku'
        // },
        // {
        //     key : 'goods_kh',
        //     text: '商品款号'
        // },
        // {
        //     key : 'goods_name',
        //     text: '商品名称'
        // },
        {
          key: "dbid",
          text: "打标id",
        },
        {
          key: "user_mobile",
          text: "用户手机号",
        },
        {
          key: "os_sn",
          text: "工单号",
        },
      ],
      artificialDamageSearchList: [
        {
          key: "all",
          text: "全部",
          value: "0",
        },
        {
          key: "artificial",
          text: "人为",
          value: "1",
        },
        {
          key: "notArtificial",
          text: "非人为",
          value: "2",
        },
        {
          key: "notJudge",
          text: "未判断",
          value: "3",
        },
      ],
      verify: false,
      showNodata: false,
      dialogVisible: true,
      resData: null,
      form: {
        create_time: this.defaultDate(),
        status: "",
        referer: 1,
        city: "0",
        is_search: 1,
        page: 1,
        is_son_order: "", // 是否子工单
      },
      loading: false, // 加载动画是否显示
      url: "/erp/reject/workList",
      status: "",
      curPage: 1,
      tableLoading: false,
      filterFold: false,
      isShow: false,
      page_size: 10,
      work_id: 0,
      showDialog: true,
      show_search: true,
      showEdit: false,
      showLog: false,
      sendBf: false,
      tempData: {},
      is_first: 1,
      searchOptions: null,
      fullScreenAlertSetting: {},
      is_son_order: false,
      action: `${apiBaseURL}/erp/reject/importBackShippingInfo`,
      artificialDamageMap: {
        0: "全部",
        1: "人为",
        2: "非人为",
        3: "未判断",
      },
    };
  },
  computed: {
    filteredForm() {
      this.form.key = this.key_word;
      this.form.content = this.key_content;
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    noDataWorkGoods() {
      this.showNodata = true;
    },
    showImages(img) {
      this.showbox = true;
      this.images = img;
    },
    closeBox() {
      this.showbox = false;
    },
    InArray(search, array) {
      for (const i in array) {
        if (array[i] == search) {
          return true;
        }
      }
      return false;
    },
    handleSizeChange(val) {
      this.form.page_size = val;
    },
    defaultDate() {
      return [];
      const endDate = new Date();
      const endM =
        endDate.getMonth() + 1 < 10
          ? `0${endDate.getMonth() + 1}`
          : endDate.getMonth() + 1;
      const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()} 23:59:59`;

      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 2);
      const startM =
        startDate.getMonth() + 1 < 10
          ? `0${startDate.getMonth() + 1}`
          : startDate.getMonth() + 1;
      const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()} 00:00:00`;
      return [start, end];
    },
    getKeyWord(e) {
      this.key_word = e;
    },
    handleEdit(id) {
      this.work_id = Number(id);
      this.showEdit = true;
    },
    doSendBf(id) {
      this.work_id = Number(id);
      this.sendBf = true;
    },
    redireToWork() {
      let host = "http://test1.yishou.com";
      let redirect_url = "/Ysadmin/WorkOrder/wo_list";
      if (
        window.location.hostname == "erp.yishouapp.com" ||
        window.location.hostname == "erpweb.yishouapp.com"
      ) {
        redirect_url = "/WorkOrder/wo_list";
        host = "https://d0k0.yishouapp.com";
      }
      const url = host + redirect_url;
      window.open(url);
    },
    redireToOrder(order_id) {
      const redirect_url = `/newos/order/order_detail?order_id=${order_id}`;
      let host = "http://test1.yishou.com";
      if (
        window.location.hostname == "erp.yishouapp.com" ||
        window.location.hostname == "erpweb.yishouapp.com"
      ) {
        host = "https://d0k0.yishouapp.com";
      }
      const url = host + redirect_url;
      window.open(url);
    },
    showLogList(id) {
      this.work_id = Number(id);
      this.showLog = true;
    },
    show_ship(shipping_num) {
      window.open(`https://m.ickd.cn/result.html#com=auto&no=${shipping_num}`);
    },
    showSearch() {
      if (this.show_search) {
        this.show_search = false;
      } else {
        this.show_search = true;
      }
    },
    sendWorkGoods() {
      this.verify = true;
    },
    onCloseDialog(e) {
      if (this.isShow) {
        this.search(this.curPage);
      }
      this.isShow = false;
      this.showEdit = false;
      this.verify = false;
      this.showLog = false;
      this.sendBf = false;
      this.showNodata = false;
    },
    handleDetail(id, is_son_order) {
      this.work_id = Number(id);
      console.log("aaa", is_son_order);
      this.is_son_order = is_son_order == "是";
      this.isShow = true;
    },
    handleClick(row) {},
    output() {
      this.form.is_excel = 1;
      this.form.get_search_options = 0;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.form.is_excel = 0;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.form.get_search_options = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.is_first = 0;
          this.searchOptions = res.data.data;
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.loading = true;
      this.$http.post(this.url, this.form).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search(page = 1) {
      this.form.is_search = 2;
      this.form.get_search_options = 0;
      this.form.page = page > 1 ? page : 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status),
            (this.curPage = this.form.page);
        }
      });
    },
    importSuccess(data) {
      if (data.code == 200) {
        this.$message.success(data.msg);
      } else {
        this.$message.e(data.msg);
      }
    },
    importError(...arg) {
      this.$message.e("导入失败了");
    },
  },
};
</script>

<style>
.work-list .row {
  height: 60px;
}

.work-list .column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.work-list .data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.work-list .filter {
  border: 1px solid #ddd;
}

.work-list .el-row {
  margin-bottom: 20px;
}

.work-list .el-row:last-child {
  margin-bottom: 0;
}

.work-list .demo-form-inline .el-form-item {
  margin-left: 40px;
}

.work-list .el-date-editor {
  width: 350px !important;
}

.package-box .el-dialog .el-dialog__header {
  padding-top: 0 !important;
}

.package-box .el-dialog .el-dialog__body {
  padding-top: 10px;
  padding-bottom: 10px;
}

.package-box .el-form-item {
  margin-bottom: 0;
}

._ctrl-item {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.order_sn_style {
  color: #0051cc;
  text-decoration: underline;
}

.order_sn_style:hover {
  color: blue;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/work/WorkList.vue